import InventoryService from "../src/services/inventoryService";
import csvService from "../src/services/csvService";

export const BuildRecipe = {
	data() {
		return {
			productParams: [
				"code",
				"cost_percent",
				"department",
				"id",
				"name",
				"prep_location",
				"preparation_instructions",
				"price",
				"recipe_cost",
				"serveware",
				"special_instructions",
				"recipe_steps"
			],
			products: [],
			articles: [],
			product: {
				code: "",
				cost_percent: 0,
				department: '',
				id: "",
				name: "",
				prep_location: "",
				preparation_instructions: "",
				price: 0,
				recipe_cost: 0,
				gross_margin: "0",
				serveware: "",
				special_instructions: "",
				outlets: []
			},
			selectedProductId: "",
			checked: "false",
			checkedLocation: "false",
			checkedEmailRecipe: "false",
			serveWares: [],
			selectedserveWares: [{ id: "" }],
			Ingredients_name: "",
			Select_Location: "",
			locations: [],
			preparationFile: "",
			image: "",
			userId: ""
		};
	},

	methods: {
		parseResponseData(response) {
			return JSON.parse(response.data);
		},
		consoleDotLog(data) {
			console.log("data", data);
		},
		getProducts(args) {
			return InventoryService.getNewRecipeList(args)
				.then(this.parseResponseData)
				.catch(this.consoleDotLog);
		},
		getLocations() {
			return InventoryService.getStoreData()
				.then(this.parseResponseData)
				.catch(this.consoleDotLog);
		},
		getProduct(productId, ...args) {
			return InventoryService.getProduct(productId, ...args)
				.then(this.parseResponseData)
				.catch(this.consoleDotLog);
		},
		getProductRecipe(productId) {
			return InventoryService.getProductRecipeData({article: productId})
				.then(this.parseResponseData)
				.catch(this.consoleDotLog);
		},
		getArticles(args) {

			InventoryService.getRawMaterial({outlet: localStorage.getItem('store_id')})
                .then((res)=>{
                    this.articles = JSON.parse(res.data);
					console.log(JSON.parse(res.data), 'JSON.parse(res.data)')
                }).catch((err)=>{
                    console.log(err)
                });
			// return InventoryService.getArticles(args)
			// 	.then(this.parseResponseData)
			// 	.catch(this.consoleDotLog);
		},
		getArticle(args) {
			return InventoryService.getArticle(args)
				.then(this.parseResponseData)
				.catch(this.consoleDotLog);
		},
		updateProduct({
			id,
			recipe_cost = 0,
			price = 0,
			prep_location = "",
			serveware = "",
			special_instructions = "",
			preparation_instructions = "",
			gross_margin = 0,
			outlets = [],
			cost_percent = 0
		} = {}) {
			return InventoryService.updateProduct(id, {
				recipe_cost,
				price,
				prep_location,
				serveware,
				special_instructions,
				preparation_instructions,
				gross_margin,
				cost_percent,
				outlets
			})
				.then(response => {
					if (response.status === 200) {
						this.$notify.success({
							title: "Success",
							message: "Product Updated Succesfully"
						});
						localStorage.setItem(this.userId, {});
						this.selectedProductId = "";
						this.product.department.name = "";
						this.product.code = "";
						this.product.prep_location = "";
						this.product.cost_percent = "";
						this.product.special_instructions = "";
						this.product.preparation_instructions = "";
						this.product.serveware = [""];
						this.selectedserveWares = [{ id: "" }];
						if (!id) {
							this.setProduct();
						}
					}
					return response;
				})
				.then(this.parseResponseData)
				.catch(err => {
					this.consoleDotLog(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Something Went Wrong"
						});
					}
				});
		},
		createRecipe(productId, params) {
			return InventoryService.createRecipe(productId, params);
			// .then(response => {
			// 	// if (response.status === 201) {
			// 	// 	this.$notify.success({
			// 	// 		title: "Success",
			// 	// 		message: "Recipe Create Succesfully"
			// 	// 	});
			// 	// }
			// 	return response;
			// })
			// .then(this.parseResponseData)
			// .catch(err => {
			// 	this.consoleDotLog(err);
			// 	// if (!200 <= err.response.status <= 299) {
			// 	// 	this.$notify.error({
			// 	// 		title: "Fail",
			// 	// 		message: "Something Went Wrong"
			// 	// 	});
			// 	// }
			// });
		},
		editRecipe(args) {
			return InventoryService.editRecipe(args);
			// .then(response => {
			// 	// if (response.status === 200) {
			// 	// 	this.$notify.success({
			// 	// 		title: "Success",
			// 	// 		message: "Recipe edited Succesfully"
			// 	// 	});
			// 	// }
			// 	return response;
			// })
			// .then(this.parseResponseData)
			// .catch(err => {
			// 	this.consoleDotLog(err);
			// 	// if (!200 <= err.response.status <= 299) {
			// 	// 	this.$notify.error({
			// 	// 		title: "Fail",
			// 	// 		message: "Something Went Wrong"
			// 	// 	});
			// 	// }
			// });
		},
		uploadPreparationMethod(args, params) {
			console.log(params);
			var formData = new FormData();
			formData.append("preparation_file", params.preparation_file);
			formData.append("image", params.image);
			return csvService
				.uploadPreparationMethod(args, formData)
				.then(response => {
					if (response.status === 201) {
						this.$notify.success({
							title: "Success",
							message: "Upload Preparation Succesfully"
						});
					}
				})
				.catch(err => {
					this.consoleDotLog(err);
					if (!200 <= err.response.status <= 299) {
						this.$notify.error({
							title: "Fail",
							message: "Upload Preparation Something Went Wrong"
						});
					}
				});
		},
		deleteIngredient(args) {
			return InventoryService.deleteIngredient(args).catch(err => {
				console.log(err);
			});
		},
		addserveWare() {
			this.selectedserveWares.push({ id: "" });
		}
	}
};
